import CurrencyUpdateDialog from './CurrencyUpdateDialog';

export default CurrencyUpdateDialog;
